import { Grid } from '@material-ui/core';
import {
  DirectionsBike as DirectionsBikeIcon,
  DirectionsBus as DirectionsBusIcon,
  DirectionsCar as DirectionsCarIcon,
  Motorcycle as MotorcycleIcon,
  TwoWheeler as TwoWheelerIcon,
} from '@material-ui/icons';
import { getTransports, updateTransport } from '@webapps/business';
import {
  useAuth,
  useMutation,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import BikeIcon from 'components/Icons/BikeIcon';
import theme from './theme';

const {
  colors: { background, subTextColor },
} = theme;

const Transport = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const { data: transports = [], refetch: refetchTransport } = useQuery(
    getTransports,
    {
      key: 'transportsSkills',
      variables: { id: idUser },
    }
  );

  const {
    isLoading: isLoadingUpdate,
    isSuccess: isSuccessUpdate,
    mutateAsync: mutateUpdateTransport,
  } = useMutation(updateTransport);

  const updateTransportStudent = async (idTransport) => {
    const myTransports = transports?.map(({ id }) => id);
    if (myTransports?.includes(idTransport)) {
      const index = myTransports?.indexOf(idTransport);
      myTransports?.splice(index, 1);
    } else {
      myTransports?.push(idTransport);
    }
    await mutateUpdateTransport({
      data: myTransports?.join(),
      id: idUser,
    });
  };

  useEffect(() => {
    if (isSuccessUpdate) {
      refetchTransport();
    }
  }, [isSuccessUpdate]);

  return (
    <div className={classes.container}>
      <div className={global.title}>
        <FormattedMessage id="student.profil.transport.title" />{' '}
        {transports.length ? '(' + transports.length + ')' : ''}
      </div>
      <div style={{marginBottom: "30px", marginTop: "8px"}}  className={global.subTitle} >
        <FormattedMessage id="Cliquez sur un moyen de transport pour en sélectionner un." />
      </div>
      <Grid
        container
        spacing={2}
        className={css({ '& > .MuiGrid-item': { padding: '10px' } })}
      >
        <Grid item xs={4}>
          <Grid
            className={css({
              background:
                transports?.filter(({ id }) => id === 'T2').length > 0
                  ? 'white'
                  : '#FAFAFA',
              borderRadius: 5,
              border: '1px solid #F0F0F5',
              cursor: 'pointer',
              '&:hover': {
                background:
                  transports?.filter(({ id }) => id === 'T2').length > 0
                    ? '#FAFAFA'
                    : 'white',
              },
              '&:hover svg': {
                color:
                  transports?.filter(({ id }) => id === 'T2').length > 0
                    ? '#5A6DA1'
                    : '#0060F9',
              },
            })}
            disabled={isLoadingUpdate}
            fullWidth
            onClick={() => updateTransportStudent('T2')}
            variant="outlined"
          >
            <div className={classes.logoPermit}>
              <DirectionsCarIcon
                className={css({
                      '@media only screen and (max-width:1920px)': {fontSize: '45px'},
    '@media only screen and (max-width:1600px)': {fontSize: '38px'},
    '@media only screen and (max-width:1200px)': {fontSize: '30px'},
                  color:
                    transports?.filter(({ id }) => id === 'T2').length > 0
                      ? '#0060F9'
                      : '#5A6DA1',
                })}
              />
            </div>
            <div
              className={cx(global.infoText, classes.textPermit)}
              style={{
                color:
                  transports?.filter(({ id }) => id === 'T2').length > 0
                    ? '#152652'
                    : '#5A6DA1',
              }}
            >
              <FormattedMessage id="student.profil.transport.type.voiture" />
            </div>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid
            className={css({
              background:
                transports?.filter(({ id }) => id === 'T3').length > 0
                  ? 'white'
                  : '#FAFAFA',
              borderRadius: 5,
              border: '1px solid #F0F0F5',
              cursor: 'pointer',
              '&:hover': {
                background:
                  transports?.filter(({ id }) => id === 'T3').length > 0
                    ? '#FAFAFA'
                    : 'white',
              },
              '&:hover svg': {
                color:
                  transports?.filter(({ id }) => id === 'T3').length > 0
                    ? '#5A6DA1'
                    : '#0060F9',
              },
            })}
            disabled={isLoadingUpdate}
            fullWidth
            onClick={() => updateTransportStudent('T3')}
            variant="outlined"
          >
            <div className={classes.logoPermit}>
              <MotorcycleIcon
                className={css({
                      '@media only screen and (max-width:1920px)': {fontSize: '45px'},
    '@media only screen and (max-width:1600px)': {fontSize: '38px'},
    '@media only screen and (max-width:1200px)': {fontSize: '30px'},
                  color:
                    transports?.filter(({ id }) => id === 'T3').length > 0
                      ? '#0060F9'
                      : '#5A6DA1',
                })}
              />
            </div>
            <div
              className={cx(global.infoText, classes.textPermit)}
              style={{
                color:
                  transports?.filter(({ id }) => id === 'T3').length > 0
                    ? '#152652'
                    : '#5A6DA1',
              }}
            >
              <FormattedMessage id="student.profil.transport.type.scooter" />
            </div>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid
            className={css({
              background:
                transports?.filter(({ id }) => id === 'T4').length > 0
                  ? 'white'
                  : '#FAFAFA',
              borderRadius: 5,
              border: '1px solid #F0F0F5',
              cursor: 'pointer',
              '&:hover': {
                background:
                  transports?.filter(({ id }) => id === 'T4').length > 0
                    ? '#FAFAFA'
                    : 'white',
              },
              '&:hover svg': {
                color:
                  transports?.filter(({ id }) => id === 'T4').length > 0
                    ? '#5A6DA1'
                    : '#0060F9',
              },
            })}
            disabled={isLoadingUpdate}
            fullWidth
            onClick={() => updateTransportStudent('T4')}
            variant="outlined"
          >
            <div className={classes.logoPermit}>
              <TwoWheelerIcon
                className={css({
                      '@media only screen and (max-width:1920px)': {fontSize: '45px'},
    '@media only screen and (max-width:1600px)': {fontSize: '38px'},
    '@media only screen and (max-width:1200px)': {fontSize: '30px'},
                  color:
                    transports?.filter(({ id }) => id === 'T4').length > 0
                      ? '#0060F9'
                      : '#5A6DA1',
                })}
              />
            </div>
            <div
              className={cx(global.infoText, classes.textPermit)}
              style={{
                color:
                  transports?.filter(({ id }) => id === 'T4').length > 0
                    ? '#152652'
                    : '#5A6DA1',
              }}
            >
              <FormattedMessage id="student.profil.transport.type.moto" />
            </div>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid
            className={css({
              background:
                transports?.filter(({ id }) => id === 'T5').length > 0
                  ? 'white'
                  : '#FAFAFA',
              borderRadius: 5,
              border: '1px solid #F0F0F5',
              cursor: 'pointer',
              '&:hover': {
                background:
                  transports?.filter(({ id }) => id === 'T5').length > 0
                    ? '#FAFAFA'
                    : 'white',
              },
              '&:hover svg': {
                color:
                  transports?.filter(({ id }) => id === 'T5').length > 0
                    ? '#5A6DA1'
                    : '#0060F9',
              },
            })}
            disabled={isLoadingUpdate}
            fullWidth
            onClick={() => updateTransportStudent('T5')}
            variant="outlined"
          >
            <div className={classes.logoPermit}>
              <DirectionsBusIcon
                className={css({
                      '@media only screen and (max-width:1920px)': {fontSize: '45px'},
    '@media only screen and (max-width:1600px)': {fontSize: '38px'},
    '@media only screen and (max-width:1200px)': {fontSize: '30px'},
                  color:
                    transports?.filter(({ id }) => id === 'T5').length > 0
                      ? '#0060F9'
                      : '#5A6DA1',
                })}
              />
            </div>
            <div
              className={cx(global.infoText, classes.textPermit)}
              style={{
                color:
                  transports?.filter(({ id }) => id === 'T5').length > 0
                    ? '#152652'
                    : '#5A6DA1',
              }}
            >
              <FormattedMessage id="student.profil.transport.type.commun" />
            </div>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid
            className={css({
              background:
                transports?.filter(({ id }) => id === 'T6').length > 0
                  ? 'white'
                  : '#FAFAFA',
              borderRadius: 5,
              border: '1px solid #F0F0F5',
              cursor: 'pointer',
              '&:hover': {
                background:
                  transports?.filter(({ id }) => id === 'T6').length > 0
                    ? '#FAFAFA'
                    : 'white',
              },
              '&:hover svg': {
                color:
                  transports?.filter(({ id }) => id === 'T6').length > 0
                    ? '#5A6DA1'
                    : '#0060F9',
              },
            })}
            disabled={isLoadingUpdate}
            fullWidth
            onClick={() => updateTransportStudent('T6')}
            variant="outlined"
          >
            <div className={classes.logoPermit}>
              <DirectionsBikeIcon
                className={css({
                      '@media only screen and (max-width:1920px)': {fontSize: '45px'},
    '@media only screen and (max-width:1600px)': {fontSize: '38px'},
    '@media only screen and (max-width:1200px)': {fontSize: '30px'},
                  color:
                    transports?.filter(({ id }) => id === 'T6').length > 0
                      ? '#0060F9'
                      : '#5A6DA1',
                })}
              />
            </div>
            <div
              className={cx(global.infoText, classes.textPermit)}
              style={{
                color:
                  transports?.filter(({ id }) => id === 'T6').length > 0
                    ? '#152652'
                    : '#5A6DA1',
              }}
            >
              <FormattedMessage id="student.profil.transport.type.velo" />
            </div>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid
            className={css({
              background:
                transports?.filter(({ id }) => id === 'T1').length > 0
                  ? 'white'
                  : '#FAFAFA',
              borderRadius: 5,
              border: '1px solid #F0F0F5',
              cursor: 'pointer',
              '&:hover': {
                background:
                  transports?.filter(({ id }) => id === 'T1').length > 0
                    ? '#FAFAFA'
                    : 'white',
              },
              '&:hover svg': {
                fill:
                  transports?.filter(({ id }) => id === 'T1').length > 0
                    ? '#5A6DA1'
                    : '#0060F9',
              },
            })}
            disabled={isLoadingUpdate}
            fullWidth
            onClick={() => updateTransportStudent('T1')}
            variant="outlined"
          >
            <div className={classes.logoPermit}>
              <BikeIcon
                className={css({
                      '@media only screen and (max-width:1920px)': {fontSize: '45px'},
    '@media only screen and (max-width:1600px)': {fontSize: '38px'},
    '@media only screen and (max-width:1200px)': {fontSize: '30px'},
                  fill:
                    transports?.filter(({ id }) => id === 'T1').length > 0
                      ? '#0060F9'
                      : '#5A6DA1',
                })}
              />
            </div>
            <div
              className={cx(global.infoText, classes.textPermit)}
              style={{
                color:
                  transports?.filter(({ id }) => id === 'T1').length > 0
                    ? '#152652'
                    : '#5A6DA1',
              }}
            >
              <FormattedMessage id="student.profil.transport.type.trottinette" />
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    flex: '1 1 0px',
    borderRadius: 10,
    padding: '20px',
    // minHeight: 340,
    height: '100%',
  },
  button: {
    height: 100,
  },
  logoPermit: {
    textAlign: 'center',
    marginTop: spacing(2),
  },
  logo: {
        '@media only screen and (max-width:1920px)': {fontSize: '45px'},
    '@media only screen and (max-width:1600px)': {fontSize: '38px'},
    '@media only screen and (max-width:1200px)': {fontSize: '30px'},
  },
  textPermit: {
    textAlign: 'center',
    color: '#152652',
    marginBottom: spacing(3),
  },
});

export default Transport;
